module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai650-d0cc338de497fd6ca26ceae96a5d632c.jpg";